<template>
  <div :style="pageStyle">
    <div class="head" v-if="!embedded">
      <div class="head-title">
        <img src="../../static/img/logo.png" class="head-logo" />
        景区旅游大数据中心
      </div>
      <div class="head-type">
        <div
          class="type-item"
          v-for="(item, index) in navItems"
          :key="index"
          :class="{ 'type-item2': index === activeNavIndex }"
          @click="typeChange(item)"
        >
          {{ item.label }}
          <div class="type-on" v-if="index === activeNavIndex"></div>
        </div>
      </div>
      <div>
        <div class="date-weather">
          <div class="changeDateOne" @click="changeTheDate(-1)">前一天</div>
          <div class="changeDateOne" @click="changeTheDate(0)">今&nbsp;&nbsp;天</div>
          <div class="changeDateOne" @click="changeTheDate(1)">后一天</div>
          <img
            @click="refreshPage"
            src="../../static/img/refresh-ccw.png"
            style="
              display: inline-block;
              width: 14px;
              height: 14px;
              vertical-align: middle;
              transform: translate(0, -2px);
              cursor: pointer;
            "
            v-if="isToday"
          />
          {{ isToday ? nowDay : req_date.replace('-', '/') }} {{ isToday ? week : changeWeek }} {{ isToday ? nowTime : '' }}
        </div>
      </div>
    </div>

    <div class="warning-main" :class="{ 'embedded-mode': embedded }">
      <div :id="mapId" class="migrateMap"></div>

      <div class="warning-record" v-if="recordVisible">
        <div class="warning-record-header">
          <span>过去30分钟拥堵告警记录</span>
          <span class="warning-record-close" @click="recordVisible = false">×</span>
        </div>
        <div class="warning-record-summary">一共 <span class="warning-record-count">{{ warningRecordCount }}</span> 条告警记录，点击可查看详情</div>
      </div>

      <div class="warning-left">
        <div class="data-box warning-panel warning-panel-large">
          <div class="warning-panel-title">重要交通枢纽分析</div>

          <div class="traffic-gateway-grid">
            <div class="traffic-gateway-block">
              <div class="traffic-gateway-subtitle">高速进入口分析 <span>负荷(%)</span></div>
              <div class="traffic-bar-row" v-for="(item, index) in entranceLoadList" :key="'entrance-' + index">
                <span class="traffic-bar-label">{{ item.name }}</span>
                <div class="traffic-bar-track">
                  <div class="traffic-bar-fill" :style="{ width: item.value + '%' }"></div>
                </div>
                <span class="traffic-bar-value">{{ item.value }}</span>
              </div>
            </div>
            <div class="traffic-gateway-block">
              <div class="traffic-gateway-subtitle">高铁站出入口分析 <span>负荷(%)</span></div>
              <div class="traffic-bar-row" v-for="(item, index) in exitLoadList" :key="'exit-' + index">
                <span class="traffic-bar-label">{{ item.name }}</span>
                <div class="traffic-bar-track">
                  <div class="traffic-bar-fill" :style="{ width: item.value + '%' }"></div>
                </div>
                <span class="traffic-bar-value">{{ item.value }}</span>
              </div>
            </div>
          </div>

          <div class="warning-section-title">
            主干道车流量与堵车率分析
            <span>(30min更新)</span>
          </div>

          <div class="road-tabs">
            <div class="road-tab road-tab-active">高速路段</div>
            <div class="road-tab">县国道</div>
          </div>

          <div class="table-box">
            <div class="table-header traffic-table-grid">
              <span>高速路口</span>
              <span>进出口车流量</span>
              <span>堵车率</span>
              <span>出口车流量</span>
              <span>堵车率</span>
            </div>
            <div class="table-scroll-body road-scroll-body">
              <div
                class="table-scroll-inner"
                :class="{ 'is-scrollable': shouldScrollRows(roadTrafficRows, 5) }"
                :style="getScrollStyle(roadTrafficRows, 3, 5)"
              >
                <div class="table-row traffic-table-grid" v-for="item in buildScrollRows(roadTrafficRows, 5)" :key="'road-' + item._scrollKey">
                  <span class="table-name">{{ item.name }}</span>
                  <span>{{ item.inFlow }}</span>
                  <span class="table-progress-cell">
                    <span class="parking-rank-track table-progress-track">
                      <span
                        class="parking-rank-fill"
                        :class="getLoadFillClass(item.inRate)"
                        :style="{ width: item.inRate + '%' }"
                      ></span>
                    </span>
                    <b :class="getLoadClass(item.inRate)">{{ item.inRate }}%</b>
                  </span>
                  <span>{{ item.outFlow }}</span>
                  <span class="table-progress-cell">
                    <span class="parking-rank-track table-progress-track">
                      <span
                        class="parking-rank-fill"
                        :class="getLoadFillClass(item.outRate)"
                        :style="{ width: item.outRate + '%' }"
                      ></span>
                    </span>
                    <b :class="getLoadClass(item.outRate)">{{ item.outRate }}%</b>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="warning-section-title warning-section-title-small">高铁站</div>
          <div class="table-box table-box-compact">
            <div class="table-header railway-table-grid">
              <span>出入口</span>
              <span>进站口人流量</span>
              <span>出站口人流量</span>
            </div>
            <div class="table-scroll-body rail-scroll-body">
              <div
                class="table-scroll-inner"
                :class="{ 'is-scrollable': shouldScrollRows(railwayRows, 4) }"
                :style="getScrollStyle(railwayRows, 2.8, 4)"
              >
                <div class="table-row railway-table-grid" v-for="item in buildScrollRows(railwayRows, 4)" :key="'rail-' + item._scrollKey">
                  <span class="table-name">{{ item.name }}</span>
                  <span>{{ item.inFlow }}</span>
                  <span>{{ item.outFlow }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="data-box warning-panel warning-panel-small">
          <div class="warning-panel-title">县主要交通拥堵情况</div>
          <div class="table-box">
            <div class="table-header county-table-grid">
              <span>市内路路段</span>
              <span>车流量(5min)</span>
              <span>堵车率</span>
            </div>
            <div class="table-scroll-body county-scroll-body">
              <div
                class="table-scroll-inner"
                :class="{ 'is-scrollable': shouldScrollRows(countyCongestionDisplayRows, 4) }"
                :style="getScrollStyle(countyCongestionDisplayRows, 3, 4)"
              >
                <div class="table-row county-table-grid" v-for="item in buildScrollRows(countyCongestionDisplayRows, 4)" :key="'county-' + item._scrollKey">
                  <span class="table-name">{{ item.name }}</span>
                  <span>{{ item.flow }}</span>
                  <span class="table-progress-cell">
                    <span class="parking-rank-track table-progress-track">
                      <span
                        class="parking-rank-fill"
                        :class="getLoadFillClass(item.rate)"
                        :style="{ width: item.rate + '%' }"
                      ></span>
                    </span>
                    <b :class="getLoadClass(item.rate)">{{ item.rate }}%</b>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="warning-map-actions">
        <div class="warning-map-button" @click="openBusRouteViewer">查看旅游公交实时路线图</div>
      </div>

      <div class="warning-right">
        <div class="data-box warning-panel parking-panel" v-for="(panel, panelIndex) in parkingPanels" :key="'parking-' + panelIndex">
          <div class="warning-panel-title">{{ panel.title }}</div>

          <div class="parking-top-grid">
            <div class="parking-top-list">
              <div class="parking-top-title">停车位充足停车场Top5</div>
              <div class="parking-rank-row" v-for="(item, index) in panel.fullTopList" :key="'full-' + panelIndex + '-' + index">
                <span class="parking-rank-index">{{ index + 1 }}</span>
                <span class="parking-rank-name">{{ item.name }}</span>
                <div class="parking-rank-track">
                  <div class="parking-rank-fill parking-rank-fill-cyan" :style="{ width: item.value + '%' }"></div>
                </div>
                <span class="parking-rank-value parking-rank-value-green">{{ item.value }}%</span>
              </div>
            </div>

            <div class="parking-top-list">
              <div class="parking-top-title">停车位不足停车场Top5</div>
              <div class="parking-rank-row" v-for="(item, index) in panel.lessTopList" :key="'less-' + panelIndex + '-' + index">
                <span class="parking-rank-index">{{ index + 1 }}</span>
                <span class="parking-rank-name">{{ item.name }}</span>
                <div class="parking-rank-track">
                  <div class="parking-rank-fill parking-rank-fill-gold" :style="{ width: item.value + '%' }"></div>
                </div>
                <span class="parking-rank-value parking-rank-value-gold">{{ item.value }}%</span>
              </div>
            </div>
          </div>

          <div class="warning-section-title parking-table-title">{{ panel.subTitle }}</div>

          <div class="table-box parking-table-box">
            <div class="table-header parking-table-grid">
              <span>公共停车场</span>
              <span>进</span>
              <span>出</span>
              <span>总量</span>
              <span>余位</span>
              <span>饱和度</span>
            </div>
            <div class="table-scroll-body parking-scroll-body">
              <div
                class="table-scroll-inner"
                :class="{ 'is-scrollable': shouldScrollRows(panel.rows, 6) }"
                :style="getScrollStyle(panel.rows, 2.8, 6)"
              >
                <div class="table-row parking-table-grid" v-for="item in buildScrollRows(panel.rows, 6)" :key="'park-row-' + panelIndex + '-' + item._scrollKey">
                  <span class="table-name">{{ item.name }}</span>
                  <span>{{ item.inFlow }}</span>
                  <span>{{ item.outFlow }}</span>
                  <span>{{ item.total }}</span>
                  <span>{{ item.remain }}</span>
                  <span class="table-progress-cell">
                    <span class="parking-rank-track table-progress-track">
                      <span
                        class="parking-rank-fill"
                        :class="getLoadFillClass(item.rate)"
                        :style="{ width: item.rate + '%' }"
                      ></span>
                    </span>
                    <b :class="getLoadClass(item.rate)">{{ item.rate }}%</b>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bus-route-modal" v-if="busMapVisible">
      <div class="bus-route-mask" @click="closeBusRouteViewer"></div>
      <div class="bus-route-dialog data-box">
        <div class="bus-route-header">
          <div class="bus-route-title">婺源旅游公交路线图</div>
          <div class="bus-route-close" @click="closeBusRouteViewer">×</div>
        </div>
        <div class="bus-route-body">
          <div class="bus-route-sidebar">
            <div
              class="bus-route-card"
              v-for="route in busRouteList"
              :key="route.localId"
              :class="{
                'bus-route-card-active': route.localId === selectedBusRouteId,
                'bus-route-card-disabled': route.pending
              }"
              @click="selectBusRoute(route)"
            >
              <div class="bus-route-card-title">{{ route.title }}</div>
              <div class="bus-route-card-subtitle">{{ route.subTitle }}</div>
              <div class="bus-route-card-status" v-if="route.pending">待补充线路ID</div>
              <div class="bus-route-card-status" v-else-if="route.loading">线路加载中...</div>
              <div class="bus-route-card-status bus-route-card-error" v-else-if="route.error">{{ route.error }}</div>
              <div class="bus-route-card-status bus-route-card-ok" v-else-if="route.busLine">已接入高德线路 · 模拟车辆在线</div>
              <div class="bus-route-card-realtime" v-if="getBusRouteRealtime(route.localId)">
                <span>{{ getBusRouteRealtime(route.localId).vehicleCode }}</span>
                <span>{{ getBusRouteRealtime(route.localId).statusText }}</span>
              </div>
              <div class="bus-route-card-realtime bus-route-card-realtime-sub" v-if="getBusRouteRealtime(route.localId)">
                {{ getBusRouteRealtime(route.localId).locationText }}
              </div>
            </div>

            <div class="bus-route-detail" v-if="selectedBusRoute">
              <div class="bus-route-detail-title">{{ selectedBusRoute.title }}</div>
              <div class="bus-route-detail-desc">{{ selectedBusRoute.description }}</div>
              <div class="bus-route-live-panel" v-if="selectedBusRouteRealtime">
                <div class="bus-route-live-title">模拟实时车辆</div>
                <div class="bus-route-live-grid">
                  <div class="bus-route-live-item">
                    <span class="bus-route-live-label">车牌</span>
                    <span class="bus-route-live-value">{{ selectedBusRouteRealtime.vehicleCode }}</span>
                  </div>
                  <div class="bus-route-live-item">
                    <span class="bus-route-live-label">状态</span>
                    <span class="bus-route-live-value">{{ selectedBusRouteRealtime.statusText }}</span>
                  </div>
                  <div class="bus-route-live-item">
                    <span class="bus-route-live-label">方向</span>
                    <span class="bus-route-live-value">{{ selectedBusRouteRealtime.directionText }}</span>
                  </div>
                  <div class="bus-route-live-item">
                    <span class="bus-route-live-label">速度</span>
                    <span class="bus-route-live-value">{{ selectedBusRouteRealtime.speedText }}</span>
                  </div>
                  <div class="bus-route-live-item bus-route-live-item-wide">
                    <span class="bus-route-live-label">当前位置</span>
                    <span class="bus-route-live-value">{{ selectedBusRouteRealtime.locationText }}</span>
                  </div>
                  <div class="bus-route-live-item">
                    <span class="bus-route-live-label">距终点</span>
                    <span class="bus-route-live-value">{{ selectedBusRouteRealtime.distanceToTerminalText }}</span>
                  </div>
                  <div class="bus-route-live-item">
                    <span class="bus-route-live-label">更新时间</span>
                    <span class="bus-route-live-value">{{ selectedBusRouteRealtime.updatedAtText }}</span>
                  </div>
                </div>
              </div>
              <div class="bus-route-detail-table">
                <div class="bus-route-detail-row" v-for="(item, index) in selectedBusRouteDetails" :key="'detail-' + index">
                  <span class="bus-route-detail-label">{{ item.label }}</span>
                  <span class="bus-route-detail-value">{{ item.value }}</span>
                </div>
              </div>
              <div class="bus-route-detail-tip">
                当前接入的是高德公交线路查询与线路绘制能力。
                当前车辆位置、车牌号与速度为前端模拟演示数据。
                如需真实车牌和实时位置，需要额外接入车载 GPS 或第三方实时公交数据源。
              </div>
            </div>
          </div>

          <div class="bus-route-map-wrapper">
            <div class="bus-route-simulation-badge" v-if="busRealtimeSummaryList.length">实时车辆位置为前端模拟演示</div>
            <div class="bus-route-loading" v-if="busRouteLoading">正在加载高德公交线路...</div>
            <div class="bus-route-error" v-if="busRouteError">{{ busRouteError }}</div>
            <div :id="busMapId" class="bus-route-map"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/index'
import { getSettingByIdApi } from '../api/ScenicAPI'
import { loadAmapSdk, queryAmapBusLineById, queryAmapBusLineByName, queryAmapBusLineByNameWebService, parseBusLinePath, getBusLineStations, getBusLineEndpoints, getPrimaryBusSegment, getBusLineIdentifier } from '@/utils/amapBus'

const WUYUAN_CENTER = {
  lat: 29.254015,
  lng: 117.861488
}

const WUYUAN_BOUNDARY_LOCAL_URL = process.env.NODE_ENV === 'production'
  ? '/static/big_data_web/geo/361130.json'
  : '/static/geo/361130.json'
const WUYUAN_BOUNDARY_REMOTE_URL = 'https://geo.datav.aliyun.com/areas_v3/bound/361130.json'
const WUYUAN_BOUNDARY_URLS = [WUYUAN_BOUNDARY_LOCAL_URL, WUYUAN_BOUNDARY_REMOTE_URL]
const WUYUAN_VIEW_HORIZONTAL_PADDING_RATIO = 0.38
const WUYUAN_VIEW_VERTICAL_PADDING_RATIO = 0.18
const AMAP_JS_KEY = '5f37c2102d3eae8ff03935c02ab786d9'
const AMAP_WEB_SERVICE_KEY = '6437941568e2e713dbae119c700f1f8a'
const BUS_MAP_ID = 'warningBusRouteMap'
const BUS_ROUTE_STROKE_COLORS = ['#4aa7ff', '#31f0c5', '#ffd76a']
const BUS_ROUTE_ACTIVE_COLOR = '#ffd76a'
const BUS_ROUTE_SIMULATION_TICK_MS = 1200
const BUS_ROUTE_SIMULATION_DWELL_SECONDS = 7

const BUS_ROUTE_DEFINITIONS = [
  {
    localId: 'wuyuan-route-1',
    lineId: '',
    lineName: '婺源-篁岭',
    title: '婺源-篁岭',
    subTitle: '旅游专线',
    description: '通过高德公交名称查询锁定“婺源-篁岭”线路，并展示线路轨迹。',
    detailRows: [
      { label: '起点', value: '篁岭景区' },
      { label: '终点', value: '婺源火车站' },
      { label: '经停站点', value: '篁岭景区 → 江湾景区 → 婺女洲景区公交站（鑫邦城门口） → 老北站公交站 → 民政局公交站 → 婺源火车站' },
      { label: '发车频率', value: '大约每1小时一班' },
      { label: '首班时间', value: '约9:00~9:30' },
      { label: '末班时间', value: '约17:20（婺源站发车）/ 18:30（篁岭发车）' },
      { label: '运行时长', value: '约50分钟' },
      { label: '票价', value: '婺源高铁站→篁岭景区 19元/人；婺源高铁站→江湾景区 13元/人' }
    ],
    mockVehicleCode: '赣H·游201',
    mockLabel: '专1',
    mockSpeedKmh: 36,
    mockStartProgress: 0.18,
    mockDirection: 1
  },
  {
    localId: 'wuyuan-route-2',
    lineId: '',
    lineName: '婺源521路',
    title: '婺源站-婺女洲景区',
    subTitle: '景区接驳线',
    description: '通过高德公交名称查询锁定“婺源521路”线路，并展示线路轨迹。',
    detailRows: [
      { label: '起点', value: '婺源火车站（高铁站）' },
      { label: '终点', value: '婺女洲度假区' },
      { label: '经停站点', value: '火车站 → 共大 → 茶博府 → 东门农贸市场 → 江西银行 → 玉宇花园 → 工商小区 → 老北站 → 浅水湾 → 博物馆 → 婺女洲景区' },
      { label: '发车频率', value: '高峰约10分钟/趟，平峰约17分钟/趟' },
      { label: '首班时间', value: '08:30' },
      { label: '末班时间', value: '18:35' },
      { label: '运行时长', value: '约25~30分钟' },
      { label: '票价', value: '0元~2元（以实际线路计费为准）' }
    ],
    mockVehicleCode: '赣H·游521',
    mockLabel: '521',
    mockSpeedKmh: 28,
    mockStartProgress: 0.62,
    mockDirection: -1
  }
]

const WUYUAN_HEAT_POINTS = [
  { name: '婺女洲', lat: 29.248238, lng: 117.890132, count: 92 },
  { name: '月亮湾', lat: 29.326918, lng: 117.946742, count: 76 },
  { name: '李坑', lat: 29.336004, lng: 117.959221, count: 84 },
  { name: '汪口', lat: 29.316551, lng: 118.015337, count: 68 },
  { name: '江湾', lat: 29.408924, lng: 118.036428, count: 95 },
  { name: '晓起', lat: 29.422785, lng: 118.066138, count: 62 },
  { name: '篁岭', lat: 29.361509, lng: 117.996186, count: 98 },
  { name: '思溪延村', lat: 29.359347, lng: 117.801713, count: 58 },
  { name: '灵岩洞', lat: 29.270215, lng: 117.708824, count: 46 },
  { name: '卧龙谷', lat: 29.479124, lng: 117.773842, count: 52 },
  { name: '严田古樟', lat: 29.314671, lng: 117.737193, count: 40 },
  { name: '彩虹桥', lat: 29.338845, lng: 117.622175, count: 44 }
]

const ROAD_TRAFFIC_BASE_ROWS = [
  { name: '婺源高速口', inFlow: 386, outFlow: 342 },
  { name: '婺源北高速口', inFlow: 324, outFlow: 298 },
  { name: '江湾高速口', inFlow: 278, outFlow: 256 },
  { name: '清华高速口', inFlow: 244, outFlow: 228 },
  { name: '沱川高速口', inFlow: 198, outFlow: 176 },
  { name: '溪头高速出-入口', inFlow: 266, outFlow: 241 },
  { name: '赋春高速口', inFlow: 186, outFlow: 173 },
  { name: '德兴-婺源交界', inFlow: 312, outFlow: 287 },
  { name: '景德镇-婺源交界', inFlow: 336, outFlow: 304 },
  { name: '黄山-婺源交界', inFlow: 358, outFlow: 319 }
]

function getRandomTrafficRate(min, max) {
  const start = typeof min === 'number' ? min : 10
  const end = typeof max === 'number' ? max : 20
  return Math.floor(Math.random() * (end - start + 1)) + start
}

function createRoadTrafficRows() {
  return ROAD_TRAFFIC_BASE_ROWS.map(item => Object.assign({}, item, {
    inRate: getRandomTrafficRate(10, 20),
    outRate: getRandomTrafficRate(10, 20)
  }))
}

function createParkingRowsWithDirection(rows) {
  return (rows || []).map((item, index) => {
    const total = Number(item.total) || 0
    let inFlow = Number(item.inFlow) || 0
    let outFlow = Number(item.outFlow) || 0

    // 如果没有传入进出数据，则生成随机数据（饱和度控制在70%以上）
    if (inFlow === 0 && outFlow === 0 && total > 0) {
      // 目标饱和度: 70% - 95%
      const targetSaturation = 70 + Math.floor(Math.random() * 26) // 70-95
      const occupied = Math.round(total * targetSaturation / 100)
      // 出流量为已占用的5%-15%
      outFlow = Math.max(1, Math.round(occupied * (0.05 + Math.random() * 0.1)))
      // 进流量 = 已占用 + 出流量
      inFlow = occupied + outFlow
    }

    // 饱和度 = (进 - 出) / 总量 * 100
    const saturation = total > 0 ? Math.round((inFlow - outFlow) / total * 100) : 0
    // 计算当前占用数（基于饱和度）
    const occupied = Math.max(0, Math.round(total * saturation / 100))
    const remain = Math.max(0, total - occupied)
    const rate = Math.max(0, saturation)

    return Object.assign({}, item, {
      total: total,
      remain: remain,
      rate: rate,
      inFlow: inFlow,
      outFlow: outFlow
    })
  })
}

function fetchJson(url) {
  if (typeof window !== 'undefined' && window.fetch) {
    return window.fetch(url).then(response => {
      if (!response.ok) {
        throw new Error('边界数据请求失败(' + response.status + '): ' + url)
      }
      return response.json()
    })
  }

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) {
        return
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          resolve(JSON.parse(xhr.responseText))
        } catch (error) {
          reject(error)
        }
      } else {
        reject(new Error('边界数据请求失败(' + xhr.status + '): ' + url))
      }
    }
    xhr.onerror = function () {
      reject(new Error('边界数据请求失败: ' + url))
    }
    xhr.send()
  })
}

function fetchJsonWithFallback(urls) {
  const sourceList = Array.isArray(urls) ? urls.filter(Boolean) : []
  let currentIndex = 0
  let lastError = null

  const tryNext = () => {
    if (currentIndex >= sourceList.length) {
      return Promise.reject(lastError || new Error('边界数据请求失败'))
    }
    const currentUrl = sourceList[currentIndex++]
    return fetchJson(currentUrl).catch(error => {
      lastError = error
      return tryNext()
    })
  }

  return tryNext()
}

export default {
  props: {
    embedded: {
      type: Boolean,
      default: false
    },
    mapId: {
      type: String,
      default: 'warningMigrateMap'
    }
  },
  data() {
    return {
      navItems: [
        { label: '文旅市场', path: '/', query: { typeIndex: 0 } },
        { label: '客流分析', path: '/scenic_date_data', query: { typeIndex: 0 } },
        { label: '大数据驾驶舱', path: '/', query: { typeIndex: 2 } },
        { label: '客流预警', path: '/scenic_warning', query: {} }
      ],
      activeNavIndex: 3,
      scenic_id: '',
      req_date: null,
      isToday: true,
      nowDay: '',
      nowDay2: '',
      nowTime: '',
      week: '',
      changeWeek: '',
      hour: '',
      weather: {},
      warningRecordCount: 10,
      recordVisible: true,
      setting: {
        map_show: 5,
        lat_offset: 0,
        lng_offset: 0
      },
      map: null,
      flightMap: null,
      boundaryLayer: null,
      boundaryGeometries: [],
      boundaryBounds: null,
      viewportBounds: null,
      heatMapPoints: [],
      amap: null,
      busMap: null,
      busMapVisible: false,
      busMapId: BUS_MAP_ID,
      busRouteLoading: false,
      busRouteError: '',
      selectedBusRouteId: 'wuyuan-route-1',
      busRouteList: BUS_ROUTE_DEFINITIONS.map(function (item, index) {
        return Object.assign({}, item, {
          loading: false,
          error: '',
          busLine: null,
          strokeColor: BUS_ROUTE_STROKE_COLORS[index % BUS_ROUTE_STROKE_COLORS.length]
        })
      }),
      busRoutePolylineMap: {},
      busRouteEndpointMarkers: [],
      busRouteInfoWindow: null,
      busRouteInfoWindowRouteId: '',
      busRouteInfoWindowAutoFollow: false,
      busRouteRealtimeMap: {},
      busRouteVehicleMarkerMap: {},
      busRouteSimulationTimer: null,
      busRouteSimulationLastTick: 0,
      clockTimer: null,
      entranceLoadList: [
        { name: '婺源高速口', value: 79 },
        { name: '婺源北高速口', value: 66 },
        { name: '江湾高速口', value: 58 },
        { name: '清华高速口', value: 42 },
        { name: '沱川高速口', value: 35 },
        { name: '溪头高速出-入口', value: 48 },
        { name: '赋春高速口', value: 31 }
      ],
      exitLoadList: [
        { name: '婺源高铁站入口', value: 69 },
        { name: '婺源高铁站负一出口', value: 52 }
      ],
      roadTrafficRows: createRoadTrafficRows(),
      railwayRows: [
        { name: '婺源高铁站入口', inFlow: 428, outFlow: '--' },
        { name: '婺源高铁站负一出口', inFlow: '--', outFlow: 396 }
      ],
      parkingPanels: [
        {
          title: '县内公共停车场分析',
          subTitle: '县内公共停车场车位分析',
          fullTopList: [
            { name: '婺源中学邻里中心停车场', value: 30 },
            { name: '锦屏路停车场', value: 30 },
            { name: '夕阳红路停车场', value: 31 },
            { name: '老外贸公司停车场', value: 29 },
            { name: '环城北路停车场', value: 34 }
          ],
          lessTopList: [
            { name: '月亮湾停车场', value: 6 },
            { name: '文博艺术公园停车场', value: 9 },
            { name: '老北站停车场', value: 12 },
            { name: '高铁站综合停车场', value: 15 },
            { name: '现代服务业大厦南侧停车场', value: 18 }
          ],
          rows: createParkingRowsWithDirection([
            { name: '婺源中学邻里中心停车场', flow: 186, total: 800, remain: 240, rate: 30 },
            { name: '锦屏路停车场', flow: 164, total: 50, remain: 15, rate: 30 },
            { name: '夕阳红路停车场', flow: 148, total: 50, remain: 16, rate: 31 },
            { name: '老外贸公司停车场', flow: 138, total: 50, remain: 15, rate: 29 },
            { name: '环城北路停车场', flow: 172, total: 50, remain: 17, rate: 34 },
            { name: '月亮湾停车场', flow: 214, total: 50, remain: 3, rate: 6 },
            { name: '文博艺术公园停车场', flow: 236, total: 100, remain: 9, rate: 9 },
            { name: '老北站停车场', flow: 252, total: 250, remain: 30, rate: 12 },
            { name: '高铁站综合停车场', flow: 318, total: 442, remain: 66, rate: 15 },
            { name: '现代服务业大厦南侧停车场', flow: 142, total: 141, remain: 25, rate: 18 }
          ])
        },
        {
          title: '景区公共停车场分析',
          subTitle: '景区公共停车场车位分析',
          fullTopList: [
            { name: '篁岭景区停车场', value: 25 },
            { name: '江湾景区停车场', value: 30 },
            { name: '婺女洲度假区停车场', value: 20 },
            { name: '卧龙谷景区停车场', value: 31 },
            { name: '弦高古城停车场', value: 26 }
          ],
          lessTopList: [
            { name: '晓起景区停车场', value: 5 },
            { name: '汪口景区停车场', value: 8 },
            { name: '李坑景区停车场', value: 11 },
            { name: '灵岩洞景区停车场', value: 14 },
            { name: '严田景区停车场', value: 17 }
          ],
          rows: createParkingRowsWithDirection([
            { name: '篁岭景区停车场', flow: 326, total: 2180, remain: 545, rate: 25, inFlow: 4998, outFlow: 2993 },
            { name: '江湾景区停车场', flow: 284, total: 80, remain: 24, rate: 30, inFlow: 348, outFlow: 288 },
            { name: '婺女洲度假区停车场', flow: 412, total: 400, remain: 80, rate: 20, inFlow: 1305, outFlow: 981 },
            { name: '卧龙谷景区停车场', flow: 215, total: 80, remain: 25, rate: 31 },
            { name: '弦高古城停车场', flow: 198, total: 1500, remain: 390, rate: 26 },
            { name: '晓起景区停车场', flow: 305, total: 75, remain: 4, rate: 5 },
            { name: '汪口景区停车场', flow: 292, total: 75, remain: 6, rate: 8 },
            { name: '李坑景区停车场', flow: 338, total: 75, remain: 8, rate: 11 },
            { name: '灵岩洞景区停车场', flow: 174, total: 75, remain: 11, rate: 14 },
            { name: '严田景区停车场', flow: 166, total: 75, remain: 13, rate: 17 },
            { name: '文公山景区停车场', flow: 148, total: 70, remain: 24, rate: 34 },
            { name: '石城景区停车场', flow: 126, total: 70, remain: 22, rate: 32 },
            { name: '彩虹桥景区停车场', flow: 208, total: 65, remain: 16, rate: 25 }
          ])
        }
      ]
    }
  },
  computed: {
    pageStyle() {
      return this.embedded
        ? 'width:100%;height:100%;font-family:PingFang SC;user-select:none;'
        : 'width:100vw;height:100vh;font-family:PingFang SC;user-select:none;'
    },
    selectedBusRoute() {
      for (let index = 0; index < this.busRouteList.length; index++) {
        if (this.busRouteList[index].localId === this.selectedBusRouteId) {
          return this.busRouteList[index]
        }
      }
      return null
    },
    selectedBusRouteDetails() {
      const route = this.selectedBusRoute
      if (!route) {
        return []
      }
      const details = route.detailRows ? route.detailRows.slice() : []
      if (!route.busLine) {
        return details
      }

      const busLine = route.busLine
      const primarySegment = getPrimaryBusSegment(busLine)
      const stations = getBusLineStations(busLine)
      const stationText = stations.length ? stations.map(item => item.name).join(' → ') : ''
      const startTime = primarySegment ? (primarySegment.starttime || primarySegment.stationStartTime || '') : (busLine.start_time || '')
      const endTime = primarySegment ? (primarySegment.endtime || primarySegment.stationEndTime || '') : (busLine.end_time || '')
      const price = primarySegment ? (primarySegment.price || busLine.expense || busLine.total_price || busLine.basic_price) : (busLine.total_price || busLine.basic_price)

      return details.map(item => {
        if (item.label === '起点' && primarySegment && primarySegment.startname) {
          return Object.assign({}, item, { value: primarySegment.startname })
        }
        if (item.label === '终点' && primarySegment && primarySegment.endname) {
          return Object.assign({}, item, { value: primarySegment.endname })
        }
        if (item.label === '经停站点' && stationText) {
          return Object.assign({}, item, { value: stationText })
        }
        if (item.label === '首班时间' && startTime) {
          return Object.assign({}, item, { value: startTime })
        }
        if (item.label === '末班时间' && endTime) {
          return Object.assign({}, item, { value: endTime })
        }
        if (item.label === '票价' && price) {
          return Object.assign({}, item, { value: '约' + price + '元/人' })
        }
        return item
      })
    },
    selectedBusRouteRealtime() {
      return this.selectedBusRouteId ? (this.busRouteRealtimeMap[this.selectedBusRouteId] || null) : null
    },
    countyCongestionDisplayRows() {
      return this.roadTrafficRows.map(item => ({
        name: item.name,
        flow: item.inFlow + item.outFlow,
        rate: Math.max(item.inRate, item.outRate)
      }))
    },
    busRealtimeSummaryList() {
      return this.busRouteList.map(route => {
        const realtime = this.busRouteRealtimeMap[route.localId]
        if (!realtime) {
          return null
        }
        return {
          localId: route.localId,
          title: route.title,
          vehicleCode: realtime.vehicleCode
        }
      }).filter(Boolean)
    }
  },
  mounted() {
    if (!this.$route.query.id) {
      const id = sessionStorage.getItem('scenicId')
      this.$router.push({ path: '/scenic_warning', query: { id: id, token: store.state.token } })
      this.$router.go(0)
      return
    }

    this.scenic_id = this.$route.query.id
    this.getToday()

    if (this.$route.query.date) {
      this.req_date = this.$route.query.date
      if (this.req_date) {
        const reDate = new Date(this.req_date)
        this.changeWeek = this.getWeek(reDate.getDay())
      }
    }

    if (this.$route.query.token) {
      this.$store.commit('setToken', this.$route.query.token)
    }

    this.isToday = !(this.req_date && this.req_date !== '' && this.req_date !== this.nowDay2)
    this.startClock()
    this.initPage()
  },
  beforeDestroy() {
    if (this.clockTimer) {
      clearInterval(this.clockTimer)
      this.clockTimer = null
    }
    if (this.boundaryLayer && this.boundaryLayer.setMap) {
      this.boundaryLayer.setMap(null)
      this.boundaryLayer = null
    }
    this.stopBusRouteSimulation()
    if (this.busRouteInfoWindow && this.busRouteInfoWindow.close) {
      this.busRouteInfoWindow.close()
      this.busRouteInfoWindow = null
    }
    this.busRouteInfoWindowRouteId = ''
    this.busRouteInfoWindowAutoFollow = false
    this.clearBusRouteVehicleMarkers()
    this.clearBusRouteEndpointMarkers()
    if (this.busMap && this.busMap.destroy) {
      this.busMap.destroy()
      this.busMap = null
    }
    if (this.flightMap) {
      this.flightMap.remove()
      this.flightMap = null
    }
    if (this.map && this.map.destroy) {
      this.map.destroy()
      this.map = null
    }
  },
  methods: {
    initPage() {
      this.getSettingById().then(() => {
        this.loadWuyuanBoundaryAndRender()
      })
    },
    refreshPage() {
      this.getToday()
      this.isToday = !(this.req_date && this.req_date !== '' && this.req_date !== this.nowDay2)
      this.initPage()
    },
    startClock() {
      if (this.clockTimer) {
        clearInterval(this.clockTimer)
        this.clockTimer = null
      }
      if (!this.isToday) {
        return
      }
      this.clockTimer = setInterval(() => {
        this.getToday()
      }, 1000)
    },
    getLoadClass(value) {
      if (value >= 90) {
        return 'load-high'
      }
      if (value >= 60) {
        return 'load-medium'
      }
      return 'load-low'
    },
    getLoadFillClass(value) {
      if (value >= 90) {
        return 'table-progress-fill-high'
      }
      if (value >= 60) {
        return 'table-progress-fill-medium'
      }
      return 'table-progress-fill-low'
    },
    shouldScrollRows(rows, visibleCount) {
      return !!(rows && rows.length > visibleCount)
    },
    buildScrollRows(rows, visibleCount) {
      if (!rows || !rows.length) {
        return []
      }
      const firstGroup = rows.map((item, index) => Object.assign({}, item, { _scrollKey: '0-' + index }))
      if (!this.shouldScrollRows(rows, visibleCount || 1)) {
        return firstGroup
      }
      const secondGroup = rows.map((item, index) => Object.assign({}, item, { _scrollKey: '1-' + index }))
      return firstGroup.concat(secondGroup)
    },
    getScrollStyle(rows, secondsPerRow, visibleCount) {
      if (!this.shouldScrollRows(rows, visibleCount || 1)) {
        return {}
      }
      return {
        animationDuration: rows.length * secondsPerRow + 's'
      }
    },
    openBusRouteViewer() {
      this.busMapVisible = true
      this.$nextTick(() => {
        this.ensureBusRouteMapReady()
      })
    },
    closeBusRouteViewer() {
      this.busMapVisible = false
      this.stopBusRouteSimulation()
      if (this.busRouteInfoWindow && this.busRouteInfoWindow.close) {
        this.busRouteInfoWindow.close()
      }
      this.busRouteInfoWindowRouteId = ''
      this.busRouteInfoWindowAutoFollow = false
    },
    ensureBusRouteMapReady() {
      this.busRouteError = ''
      this.busRouteLoading = true
      loadAmapSdk(AMAP_JS_KEY, ['AMap.LineSearch']).then(AMap => {
        this.amap = AMap
        return new Promise(resolve => {
          AMap.plugin(['AMap.LineSearch'], function () {
            resolve()
          })
        }).then(() => {
          if (!this.busMap) {
            this.busMap = new AMap.Map(this.busMapId, {
              zoom: 11,
              center: [WUYUAN_CENTER.lng, WUYUAN_CENTER.lat],
              mapStyle: 'amap://styles/darkblue',
              showLabel: true,
              viewMode: '2D'
            })
          } else if (this.busMap.resize) {
            this.busMap.resize()
          }

          const hasLoadedRoute = this.busRouteList.some(route => route.busLine)
          if (hasLoadedRoute) {
            this.busRouteLoading = false
            this.startBusRouteSimulation()
            this.highlightBusRoute(this.selectedBusRouteId)
            return
          }

          return this.fetchAmapBusRoutes().then(() => {
            this.busRouteLoading = false
            this.startBusRouteSimulation()
            this.highlightBusRoute(this.selectedBusRouteId)
          })
        })
      }).catch(error => {
        this.busRouteLoading = false
        this.busRouteError = error.message || '高德地图加载失败'
      })
    },
    fetchAmapBusRoutes() {
      const tasks = this.busRouteList.map(route => {
        if (!route.lineName) {
          return Promise.resolve()
        }
        route.loading = true
        route.error = ''
        return queryAmapBusLineByName(this.amap, {
          keyword: route.lineName,
          city: '361100',
          pageSize: 20
        }).catch(error => {
          if (!AMAP_WEB_SERVICE_KEY) {
            throw error
          }
          return queryAmapBusLineByNameWebService({
            key: AMAP_WEB_SERVICE_KEY,
            keyword: route.lineName,
            city: '361100',
            pageSize: 20
          })
        }).then(searchResult => {
          const matchedLine = this.pickMatchedLine(searchResult.lines, route.lineName)
          if (!matchedLine) {
            route.loading = false
            route.error = '未查询到同名线路'
            return
          }

          route.searchLine = matchedLine
          route.lineId = getBusLineIdentifier(matchedLine)

          if (!route.lineId) {
            route.busLine = matchedLine
            route.rawResult = searchResult.raw
            route.loading = false
            route.error = '已查到线路，但未取得lineid，已使用名称查询结果绘制'
            return
          }

          if (!AMAP_WEB_SERVICE_KEY) {
            route.busLine = matchedLine
            route.rawResult = searchResult.raw
            route.loading = false
            route.error = '缺少高德 Web服务 key，当前使用名称查询结果绘制'
            return
          }

          return queryAmapBusLineById(this.amap, {
            key: AMAP_WEB_SERVICE_KEY,
            lineId: route.lineId
          }).then(result => {
            const busLine = result && result.segmentlist && result.segmentlist.length
              ? result
              : (result && result.buslist && result.buslist.length
                ? result.buslist[0]
                : (result && result.buslines && result.buslines.length ? result.buslines[0] : null))
            route.busLine = busLine || matchedLine
            route.rawResult = result
            route.loading = false
            if (!busLine) {
              route.error = '线路详情为空，已使用名称查询结果绘制'
            }
          })
        }).catch(error => {
          route.loading = false
          route.error = error.message || '线路查询失败'
        })
      })

      return Promise.all(tasks).then(() => {
        this.drawBusRoutePolylines()
      })
    },
    pickMatchedLine(lines, lineName) {
      if (!lines || !lines.length) {
        return null
      }
      for (let index = 0; index < lines.length; index++) {
        const item = lines[index]
        if (item && item.name === lineName) {
          return item
        }
      }
      for (let index = 0; index < lines.length; index++) {
        const item = lines[index]
        if (item && item.name && item.name.indexOf(lineName) !== -1) {
          return item
        }
      }
      return lines[0]
    },
    drawBusRoutePolylines() {
      if (!this.busMap || !this.amap) {
        return
      }

      Object.keys(this.busRoutePolylineMap).forEach(localId => {
        if (this.busRoutePolylineMap[localId] && this.busRoutePolylineMap[localId].setMap) {
          this.busRoutePolylineMap[localId].setMap(null)
        }
      })
      this.busRoutePolylineMap = {}

      this.busRouteList.forEach(route => {
        if (!route.busLine) {
          return
        }
        const path = parseBusLinePath(this.amap, route.busLine)
        if (!path.length) {
          route.error = '线路缺少有效坐标'
          return
        }
        route.path = path
        route.pathMetrics = null
        const polyline = new this.amap.Polyline({
          map: this.busMap,
          path: path,
          strokeColor: route.strokeColor,
          strokeOpacity: 0.35,
          strokeWeight: 5,
          strokeStyle: 'solid',
          lineJoin: 'round',
          lineCap: 'round',
          zIndex: 30
        })
        this.busRoutePolylineMap[route.localId] = polyline
      })
    },
    getBusRouteRealtime(localId) {
      return this.busRouteRealtimeMap[localId] || null
    },
    startBusRouteSimulation() {
      if (!this.busMapVisible || !this.busMap || !this.amap) {
        return
      }
      const hasUsablePath = this.busRouteList.some(route => route.path && route.path.length > 1)
      if (!hasUsablePath) {
        return
      }
      this.busRouteSimulationLastTick = Date.now()
      this.syncBusRouteRealtime(0)
      if (this.busRouteSimulationTimer) {
        return
      }
      this.busRouteSimulationTimer = setInterval(() => {
        const now = Date.now()
        const elapsedSeconds = Math.max((now - this.busRouteSimulationLastTick) / 1000, BUS_ROUTE_SIMULATION_TICK_MS / 1000)
        this.busRouteSimulationLastTick = now
        this.syncBusRouteRealtime(elapsedSeconds)
      }, BUS_ROUTE_SIMULATION_TICK_MS)
    },
    stopBusRouteSimulation() {
      if (this.busRouteSimulationTimer) {
        clearInterval(this.busRouteSimulationTimer)
        this.busRouteSimulationTimer = null
      }
    },
    syncBusRouteRealtime(elapsedSeconds) {
      this.busRouteList.forEach((route, index) => {
        if (!route.path || route.path.length < 2) {
          return
        }
        let realtime = this.busRouteRealtimeMap[route.localId]
        if (!realtime) {
          realtime = this.createBusRouteRealtimeState(route, index)
          this.$set(this.busRouteRealtimeMap, route.localId, realtime)
        }
        this.updateBusRouteRealtime(route, realtime, elapsedSeconds)
      })
    },
    createBusRouteRealtimeState(route, index) {
      const now = Date.now()
      const startName = this.getRouteTerminalName(route, 'start')
      const endName = this.getRouteTerminalName(route, 'end')
      const direction = route.mockDirection === -1 ? -1 : 1
      return {
        vehicleCode: route.mockVehicleCode || ('赣H·游' + (201 + index)),
        markerLabel: route.mockLabel || String(index + 1),
        speedKmh: route.mockSpeedKmh || 30,
        speedText: (route.mockSpeedKmh || 30) + 'km/h',
        progress: typeof route.mockStartProgress === 'number' ? route.mockStartProgress : Math.min(0.15 + index * 0.32, 0.85),
        direction: direction,
        dwellRemaining: 0,
        statusText: '模拟运行中',
        currentSegmentText: startName + ' - ' + endName,
        locationText: '当前区间 ' + startName + ' - ' + endName,
        directionText: '开往 ' + (direction === 1 ? endName : startName),
        distanceToTerminalText: '--',
        nextStopText: direction === 1 ? endName : startName,
        updatedAtText: this.formatSimulationTime(now),
        position: null
      }
    },
    updateBusRouteRealtime(route, realtime, elapsedSeconds) {
      const metrics = this.getRoutePathMetrics(route)
      if (!metrics || !metrics.totalDistance) {
        return
      }

      const startName = this.getRouteTerminalName(route, 'start')
      const endName = this.getRouteTerminalName(route, 'end')

      if (realtime.dwellRemaining > 0) {
        realtime.dwellRemaining = Math.max(0, realtime.dwellRemaining - elapsedSeconds)
      } else if (elapsedSeconds > 0) {
        const speedMetersPerSecond = Math.max(realtime.speedKmh, 18) * 1000 / 3600
        realtime.progress += realtime.direction * speedMetersPerSecond * elapsedSeconds / metrics.totalDistance
        if (realtime.progress >= 1) {
          realtime.progress = 1
          realtime.direction = -1
          realtime.dwellRemaining = BUS_ROUTE_SIMULATION_DWELL_SECONDS
        } else if (realtime.progress <= 0) {
          realtime.progress = 0
          realtime.direction = 1
          realtime.dwellRemaining = BUS_ROUTE_SIMULATION_DWELL_SECONDS
        }
      }

      const distance = metrics.totalDistance * realtime.progress
      const position = this.getPointOnRoute(route, distance)
      if (position) {
        realtime.position = position
        this.upsertBusRouteVehicleMarker(route, realtime)
      }

      const runtimeTerminal = realtime.direction === 1 ? endName : startName
      const remainingDistance = realtime.direction === 1 ? (metrics.totalDistance - distance) : distance
      const stationSnapshot = this.getRealtimeStationSnapshot(route, realtime.progress, realtime.direction, startName, endName)

      realtime.statusText = realtime.dwellRemaining > 0 ? '站点停靠中' : '模拟运行中'
      realtime.speedText = realtime.dwellRemaining > 0 ? '0km/h' : (Math.round(realtime.speedKmh) + 'km/h')
      realtime.currentSegmentText = stationSnapshot.currentSegmentText
      realtime.nextStopText = stationSnapshot.nextStopText
      realtime.locationText = realtime.dwellRemaining > 0
        ? '当前停靠 ' + stationSnapshot.nextStopText
        : '当前区间 ' + stationSnapshot.currentSegmentText
      realtime.directionText = '开往 ' + runtimeTerminal
      realtime.distanceToTerminalText = this.formatDistanceText(remainingDistance)
      realtime.updatedAtText = this.formatSimulationTime(Date.now())

      if (this.busRouteInfoWindowAutoFollow && this.busRouteInfoWindowRouteId === route.localId && this.busRouteInfoWindow && realtime.position) {
        this.busRouteInfoWindow.setContent(this.buildBusRouteRealtimeInfoContent(route, realtime))
        this.busRouteInfoWindow.open(this.busMap, realtime.position)
      }
    },
    getRealtimeStationSnapshot(route, progress, direction, startName, endName) {
      const stations = route.busLine ? getBusLineStations(route.busLine) : []
      if (!stations.length) {
        return {
          currentSegmentText: startName + ' - ' + endName,
          nextStopText: direction === 1 ? endName : startName
        }
      }
      if (progress <= 0) {
        return {
          currentSegmentText: stations[0].name || startName,
          nextStopText: stations[0].name || startName
        }
      }
      if (progress >= 1) {
        return {
          currentSegmentText: stations[stations.length - 1].name || endName,
          nextStopText: stations[stations.length - 1].name || endName
        }
      }

      const maxIndex = Math.max(stations.length - 1, 1)
      const floatIndex = progress * maxIndex
      let currentIndex = direction === 1 ? Math.floor(floatIndex) : Math.ceil(floatIndex)
      currentIndex = Math.max(0, Math.min(currentIndex, stations.length - 1))
      let nextIndex = currentIndex + direction
      nextIndex = Math.max(0, Math.min(nextIndex, stations.length - 1))

      const currentName = stations[currentIndex] && stations[currentIndex].name ? stations[currentIndex].name : (direction === 1 ? startName : endName)
      const nextName = stations[nextIndex] && stations[nextIndex].name ? stations[nextIndex].name : (direction === 1 ? endName : startName)

      return {
        currentSegmentText: currentName === nextName ? currentName : (currentName + ' - ' + nextName),
        nextStopText: nextName
      }
    },
    getRoutePathMetrics(route) {
      if (!route || !route.path || route.path.length < 2) {
        return null
      }
      if (route.pathMetrics && route.pathMetrics.totalDistance) {
        return route.pathMetrics
      }

      const cumulativeDistances = [0]
      let totalDistance = 0
      for (let index = 1; index < route.path.length; index++) {
        totalDistance += this.getLngLatDistance(route.path[index - 1], route.path[index])
        cumulativeDistances.push(totalDistance)
      }
      route.pathMetrics = {
        cumulativeDistances: cumulativeDistances,
        totalDistance: totalDistance
      }
      return route.pathMetrics
    },
    getPointOnRoute(route, distance) {
      const metrics = this.getRoutePathMetrics(route)
      if (!metrics || !metrics.totalDistance) {
        return route && route.path && route.path.length ? route.path[0] : null
      }
      if (distance <= 0) {
        return route.path[0]
      }
      if (distance >= metrics.totalDistance) {
        return route.path[route.path.length - 1]
      }

      for (let index = 1; index < metrics.cumulativeDistances.length; index++) {
        if (distance > metrics.cumulativeDistances[index]) {
          continue
        }
        const segmentStartDistance = metrics.cumulativeDistances[index - 1]
        const segmentDistance = metrics.cumulativeDistances[index] - segmentStartDistance
        const ratio = segmentDistance > 0 ? (distance - segmentStartDistance) / segmentDistance : 0
        return this.interpolateLngLat(route.path[index - 1], route.path[index], ratio)
      }

      return route.path[route.path.length - 1]
    },
    interpolateLngLat(startPoint, endPoint, ratio) {
      const start = this.normalizeLngLat(startPoint)
      const end = this.normalizeLngLat(endPoint)
      if (!start || !end || !this.amap) {
        return null
      }
      return new this.amap.LngLat(
        start.lng + (end.lng - start.lng) * ratio,
        start.lat + (end.lat - start.lat) * ratio
      )
    },
    normalizeLngLat(point) {
      if (!point) {
        return null
      }
      if (typeof point.getLng === 'function' && typeof point.getLat === 'function') {
        return {
          lng: Number(point.getLng()),
          lat: Number(point.getLat())
        }
      }
      if (typeof point.lng === 'number' && typeof point.lat === 'number') {
        return {
          lng: Number(point.lng),
          lat: Number(point.lat)
        }
      }
      return null
    },
    getLngLatDistance(startPoint, endPoint) {
      const start = this.normalizeLngLat(startPoint)
      const end = this.normalizeLngLat(endPoint)
      if (!start || !end) {
        return 0
      }
      const rad = Math.PI / 180
      const startLat = start.lat * rad
      const endLat = end.lat * rad
      const deltaLat = (end.lat - start.lat) * rad
      const deltaLng = (end.lng - start.lng) * rad
      const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
        Math.cos(startLat) * Math.cos(endLat) * Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      return 6371000 * c
    },
    formatDistanceText(distance) {
      if (!isFinite(distance) || distance <= 0) {
        return '0m'
      }
      if (distance >= 1000) {
        return (distance / 1000).toFixed(1) + 'km'
      }
      return Math.round(distance) + 'm'
    },
    formatSimulationTime(timestamp) {
      const time = new Date(timestamp)
      const hour = time.getHours() > 9 ? time.getHours() : ('0' + time.getHours())
      const minute = time.getMinutes() > 9 ? time.getMinutes() : ('0' + time.getMinutes())
      const second = time.getSeconds() > 9 ? time.getSeconds() : ('0' + time.getSeconds())
      return hour + ':' + minute + ':' + second
    },
    getRouteTerminalName(route, type) {
      const endpointList = route && route.busLine ? getBusLineEndpoints(route.busLine) : []
      const matchType = type === 'start' ? 'start' : 'end'
      for (let index = 0; index < endpointList.length; index++) {
        if (endpointList[index].type === matchType && endpointList[index].name) {
          return endpointList[index].name
        }
      }

      const label = type === 'start' ? '起点' : '终点'
      const detailRows = route && route.detailRows ? route.detailRows : []
      for (let index = 0; index < detailRows.length; index++) {
        if (detailRows[index].label === label && detailRows[index].value) {
          return detailRows[index].value
        }
      }
      return label
    },
    ensureBusRouteInfoWindow(offsetY) {
      if (!this.busRouteInfoWindow) {
        this.busRouteInfoWindow = new this.amap.InfoWindow({
          offset: new this.amap.Pixel(0, offsetY)
        })
        if (this.busRouteInfoWindow.on) {
          this.busRouteInfoWindow.on('close', () => {
            this.busRouteInfoWindowRouteId = ''
            this.busRouteInfoWindowAutoFollow = false
          })
        }
      } else if (this.busRouteInfoWindow.setOffset) {
        this.busRouteInfoWindow.setOffset(new this.amap.Pixel(0, offsetY))
      }
      return this.busRouteInfoWindow
    },
    upsertBusRouteVehicleMarker(route, realtime) {
      if (!this.busMap || !this.amap || !realtime.position) {
        return
      }
      let marker = this.busRouteVehicleMarkerMap[route.localId]
      if (!marker) {
        marker = new this.amap.Marker({
          map: this.busMap,
          position: realtime.position,
          offset: new this.amap.Pixel(-18, -18),
          zIndex: 90,
          content: this.buildBusRouteVehicleMarkerContent(route, realtime)
        })
        marker.on('click', () => {
          this.busRouteInfoWindowRouteId = route.localId
          this.busRouteInfoWindowAutoFollow = true
          const infoWindow = this.ensureBusRouteInfoWindow(-24)
          infoWindow.setContent(this.buildBusRouteRealtimeInfoContent(route, realtime))
          infoWindow.open(this.busMap, realtime.position)
        })
        this.busRouteVehicleMarkerMap[route.localId] = marker
      } else {
        marker.setPosition(realtime.position)
      }
    },
    clearBusRouteVehicleMarkers() {
      Object.keys(this.busRouteVehicleMarkerMap).forEach(localId => {
        const marker = this.busRouteVehicleMarkerMap[localId]
        if (marker && marker.setMap) {
          marker.setMap(null)
        }
      })
      this.busRouteVehicleMarkerMap = {}
    },
    buildBusRouteVehicleMarkerContent(route, realtime) {
      return '<div class="bus-vehicle-marker">' +
        '<div class="bus-vehicle-pulse" style="background:' + route.strokeColor + ';"></div>' +
        '<div class="bus-vehicle-body" style="border-color:' + route.strokeColor + ';box-shadow:0 0 12px ' + route.strokeColor + '33;">' +
        realtime.markerLabel +
        '</div>' +
        '</div>'
    },
    buildBusRouteRealtimeInfoContent(route, realtime) {
      return '<div class="bus-realtime-window">' +
        '<div class="bus-realtime-window-title">' + route.title + '</div>' +
        '<div class="bus-realtime-window-line">车辆：' + realtime.vehicleCode + '</div>' +
        '<div class="bus-realtime-window-line">状态：' + realtime.statusText + '</div>' +
        '<div class="bus-realtime-window-line">方向：' + realtime.directionText + '</div>' +
        '<div class="bus-realtime-window-line">位置：' + realtime.locationText + '</div>' +
        '<div class="bus-realtime-window-line">距终点：' + realtime.distanceToTerminalText + '</div>' +
        '<div class="bus-realtime-window-line">更新时间：' + realtime.updatedAtText + '</div>' +
        '<div class="bus-realtime-window-tip">演示数据</div>' +
        '</div>'
    },
    selectBusRoute(route) {
      this.selectedBusRouteId = route.localId
      if (route.pending) {
        return
      }
      this.highlightBusRoute(route.localId)
    },
    highlightBusRoute(localId) {
      this.selectedBusRouteId = localId
      Object.keys(this.busRoutePolylineMap).forEach(routeId => {
        const polyline = this.busRoutePolylineMap[routeId]
        const route = this.busRouteList.find(item => item.localId === routeId)
        if (!polyline || !route) {
          return
        }
        if (routeId === localId) {
          polyline.setOptions({
            strokeColor: BUS_ROUTE_ACTIVE_COLOR,
            strokeOpacity: 0.95,
            strokeWeight: 8,
            zIndex: 60
          })
        } else {
          polyline.setOptions({
            strokeColor: route.strokeColor,
            strokeOpacity: 0.28,
            strokeWeight: 4,
            zIndex: 30
          })
        }
      })

      const route = this.busRouteList.find(item => item.localId === localId)
      if (!route || !route.path || !route.path.length || !this.busMap) {
        this.clearBusRouteEndpointMarkers()
        return
      }

      this.renderBusRouteEndpointMarkers(route)
      this.busMap.setFitView([this.busRoutePolylineMap[localId]].concat(this.busRouteEndpointMarkers), false, [80, 80, 80, 420])
    },
    clearBusRouteEndpointMarkers() {
      if (!this.busRouteEndpointMarkers.length) {
        return
      }
      this.busRouteEndpointMarkers.forEach(marker => {
        if (marker && marker.setMap) {
          marker.setMap(null)
        }
      })
      this.busRouteEndpointMarkers = []
    },
    renderBusRouteEndpointMarkers(route) {
      this.clearBusRouteEndpointMarkers()
      if (!route.path || route.path.length < 2) {
        return
      }

      const endpointList = getBusLineEndpoints(route.busLine)
      const points = endpointList.length
        ? endpointList.map(item => ({
            name: item.name,
            position: new this.amap.LngLat(item.lng, item.lat),
            type: item.type === 'start' ? '起' : '终'
          }))
        : [
            { name: '起点', position: route.path[0], type: '起' },
            { name: '终点', position: route.path[route.path.length - 1], type: '终' }
          ]

      this.busRouteEndpointMarkers = points.map(point => {
        const marker = new this.amap.Marker({
          map: this.busMap,
          position: point.position,
          offset: new this.amap.Pixel(-14, -14),
          content: '<div class="bus-endpoint-marker bus-endpoint-marker-' + point.type + '">' + point.type + '</div>'
        })
        marker.on('click', () => {
          this.busRouteInfoWindowRouteId = ''
          this.busRouteInfoWindowAutoFollow = false
          const infoWindow = this.ensureBusRouteInfoWindow(-20)
          infoWindow.setContent('<div class="bus-stop-window">' + point.name + '</div>')
          infoWindow.open(this.busMap, point.position)
        })
        return marker
      })
    },
    typeChange(item) {
      const query = Object.assign({}, item.query || {}, {
        id: this.scenic_id,
        token: store.state.token
      })
      if (this.req_date) {
        query.date = this.req_date
      }
      this.$router.push({ path: item.path, query: query })
      if (item.path === this.$route.path) {
        this.$router.go(0)
      }
    },
    getWeek(day) {
      switch (day) {
        case 0: return '周日'
        case 1: return '周一'
        case 2: return '周二'
        case 3: return '周三'
        case 4: return '周四'
        case 5: return '周五'
        case 6: return '周六'
      }
    },
    getToday() {
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth() > 8 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1)
      const date = today.getDate() > 9 ? today.getDate() : '0' + today.getDate()
      this.hour = today.getHours() > 9 ? today.getHours() : '0' + today.getHours()
      const min = today.getMinutes() > 9 ? today.getMinutes() : '0' + today.getMinutes()
      const second = today.getSeconds() > 9 ? today.getSeconds() : '0' + today.getSeconds()
      this.nowDay = year + '/' + month + '/' + date
      this.nowDay2 = year + '-' + month + '-' + date
      this.nowTime = this.hour + ':' + min + ':' + second
      this.week = this.getWeek(today.getDay())
    },
    getSettingById() {
      return getSettingByIdApi({
        scenic_id: this.scenic_id
      }).then(res => {
        if (res.data && res.data.data) {
          this.setting = Object.assign({}, this.setting, res.data.data)
        }
      }).catch(() => {
        return Promise.resolve()
      })
    },
    loadWuyuanBoundaryAndRender() {
      return fetchJsonWithFallback(WUYUAN_BOUNDARY_URLS).then(data => {
        this.boundaryGeometries = this.parseBoundaryGeometries(data)
      }).catch(error => {
        this.boundaryGeometries = []
        console.warn('[ScenicWarning] 婺源县边界数据加载失败，已降级为无边界热力图。', error)
      }).then(() => {
        this.renderWuyuanHeatMap()
      })
    },
    parseBoundaryGeometries(geojson) {
      const geometries = []
      let geometryIndex = 0
      const features = geojson && geojson.features ? geojson.features : []

      const appendPolygon = polygonCoordinates => {
        if (!polygonCoordinates || !polygonCoordinates.length) {
          return
        }
        const paths = polygonCoordinates.map(ring => {
          return ring.map(point => ({
            lat: Number(point[1]),
            lng: Number(point[0])
          }))
        }).filter(ring => ring.length > 2)

        if (!paths.length) {
          return
        }

        geometries.push({
          id: 'wuyuan-boundary-' + geometryIndex++,
          styleId: 'boundary',
          paths: paths.length === 1 ? paths[0] : paths
        })
      }

      for (let index = 0; index < features.length; index++) {
        const geometry = features[index].geometry || {}
        if (geometry.type === 'Polygon') {
          appendPolygon(geometry.coordinates)
        } else if (geometry.type === 'MultiPolygon') {
          for (let polygonIndex = 0; polygonIndex < geometry.coordinates.length; polygonIndex++) {
            appendPolygon(geometry.coordinates[polygonIndex])
          }
        }
      }

      return geometries
    },
    calculateBoundaryBounds() {
      if (!this.boundaryGeometries.length) {
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      let minLat = Infinity
      let maxLat = -Infinity
      let minLng = Infinity
      let maxLng = -Infinity

      const walkPoints = points => {
        for (let index = 0; index < points.length; index++) {
          const point = points[index]
          if (Array.isArray(point)) {
            walkPoints(point)
          } else if (point && typeof point.lat === 'number' && typeof point.lng === 'number') {
            minLat = Math.min(minLat, point.lat)
            maxLat = Math.max(maxLat, point.lat)
            minLng = Math.min(minLng, point.lng)
            maxLng = Math.max(maxLng, point.lng)
          }
        }
      }

      for (let index = 0; index < this.boundaryGeometries.length; index++) {
        walkPoints(this.boundaryGeometries[index].paths)
      }

      if (!isFinite(minLat) || !isFinite(maxLat) || !isFinite(minLng) || !isFinite(maxLng)) {
        this.boundaryBounds = null
        this.viewportBounds = null
        return null
      }

      this.boundaryBounds = {
        sw: new TMap.LatLng(minLat, minLng),
        ne: new TMap.LatLng(maxLat, maxLng)
      }
      const latSpan = maxLat - minLat
      const lngSpan = maxLng - minLng
      const latPadding = latSpan * WUYUAN_VIEW_VERTICAL_PADDING_RATIO
      const lngPadding = lngSpan * WUYUAN_VIEW_HORIZONTAL_PADDING_RATIO
      this.viewportBounds = {
        sw: new TMap.LatLng(minLat - latPadding, minLng - lngPadding),
        ne: new TMap.LatLng(maxLat + latPadding, maxLng + lngPadding)
      }
      return this.boundaryBounds
    },
    renderBoundaryLayer() {
      if (!this.map || !this.boundaryGeometries.length) {
        return
      }

      if (this.boundaryLayer && this.boundaryLayer.setMap) {
        this.boundaryLayer.setMap(null)
      }

      const boundaryStyle = new TMap.PolygonStyle({
        color: 'rgba(24, 50, 112, 0.10)',
        showBorder: true,
        borderColor: 'rgba(120, 238, 255, 0.95)',
        borderWidth: 3
      })

      this.boundaryLayer = new TMap.MultiPolygon({
        map: this.map,
        zIndex: 2,
        styles: {
          boundary: boundaryStyle
        },
        geometries: this.boundaryGeometries
      })
    },
    renderWuyuanHeatMap() {
      this.heatMapPoints = WUYUAN_HEAT_POINTS.slice()
      const warningMapZoom = Math.max(Number(this.setting.map_show || 0), 11.2)
      const maxZoom = Math.max(warningMapZoom + 2.3, 14)
      this.calculateBoundaryBounds()
      const mapBounds = this.viewportBounds || this.boundaryBounds
      const center = new TMap.LatLng(
        WUYUAN_CENTER.lat + Number(this.setting.lat_offset || 0),
        WUYUAN_CENTER.lng + Number(this.setting.lng_offset || 0)
      )

      if (this.boundaryLayer && this.boundaryLayer.setMap) {
        this.boundaryLayer.setMap(null)
        this.boundaryLayer = null
      }
      if (this.flightMap) {
        this.flightMap.remove()
        this.flightMap = null
      }
      if (this.map && this.map.destroy) {
        this.map.destroy()
        this.map = null
      }

      const mapOptions = {
        zoom: warningMapZoom,
        minZoom: warningMapZoom,
        maxZoom: maxZoom,
        pitch: 12,
        center: center,
        mapStyleId: 'style3',
        showControl: false,
        baseMap: {
          type: 'vector',
          features: ['base', 'building3d', 'point']
        }
      }
      if (mapBounds) {
        mapOptions.boundary = new TMap.LatLngBounds(mapBounds.sw, mapBounds.ne)
      }

      this.map = new TMap.Map(this.mapId, mapOptions)

      this.flightMap = new TMap.visualization.Heat({
        max: 100,
        min: 0,
        height: 6,
        radius: 28
      }).addTo(this.map)
      this.flightMap.setOpacity(0.8)
      const gradient = this.flightMap.getGradientColor()
      gradient.stops[0.1] = '#fff'
      gradient.stops[0.3] = '#5589f2'
      gradient.stops[0.6] = '#E9AB1D'
      gradient.stops[0.8] = '#e53f31'
      gradient.stops[0.99] = '#b84b41'
      gradient.stops[1.0] = '#652074'
      this.flightMap.setGradientColor(gradient)
      this.flightMap.setData(this.heatMapPoints)
      this.renderBoundaryLayer()
    },
    changeTheDate(day) {
      if (day === 0) {
        const query = {
          id: this.scenic_id,
          token: store.state.token
        }
        this.$router.push({ path: '/scenic_warning', query: query })
        this.$router.go(0)
        return
      }

      const today = this.req_date ? new Date(this.req_date) : new Date()
      const targetdayMilliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
      today.setTime(targetdayMilliseconds)
      const tYear = today.getFullYear()
      let tMonth = today.getMonth()
      let tDate = today.getDate()
      tMonth = this.doHandleMonth(tMonth + 1)
      tDate = this.doHandleMonth(tDate)
      const date = tYear + '-' + tMonth + '-' + tDate
      this.$router.push({
        path: '/scenic_warning',
        query: {
          id: this.scenic_id,
          date: date,
          token: store.state.token
        }
      })
      this.$router.go(0)
    },
    doHandleMonth(month) {
      let m = month
      if (month.toString().length === 1) {
        m = '0' + month
      }
      return m
    }
  }
}
</script>

<style scoped>
.head {
  position: relative;
  display: flex;
  padding: 0 20px;
  width: 100%;
  height: 54px;
  line-height: 54px;
  background-color: #141439;
  justify-content: space-between;
  z-index: 5;
}

.head-title {
  display: inline-block;
  font-size: 16px;
  vertical-align: middle;
}

.head-logo {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  transform: translate(0, -2px);
}

.head-type {
  width: 520px;
  max-width: 100%;
  height: 54px;
  display: flex;
  justify-content: space-around;
  vertical-align: middle;
}

.type-item {
  position: relative;
  height: 100%;
  display: inline-block;
  color: #575785;
  cursor: pointer;
}

.type-item2 {
  color: #fff;
}

.type-on {
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #023AFF;
  border-radius: 1px;
}

.date-weather {
  display: inline-block;
  padding: 0 15px;
  height: 36px;
  line-height: 36px;
  background-color: #040932;
  font-size: 13px;
  border-radius: 17px;
  vertical-align: middle;
}

.changeDateOne {
  margin-right: 10px;
  display: inline-block;
  width: 66px;
  height: 32px;
  font-size: 15px;
  text-align: center;
  color: #01F1E3;
  line-height: 32px;
  font-weight: 600;
  background-image: url(../../static/img/year-top.png), url(../../static/img/year-bottom.png), url(../../static/img/year-bgc.png);
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-size: auto auto, auto auto, 110px 65px;
  background-position: right top, left bottom, center center;
  cursor: pointer;
}

.warning-main {
  position: relative;
  width: 100%;
  height: calc(100vh - 54px);
  overflow: hidden;
  padding: 28px 26px 18px;
  box-sizing: border-box;
}

.warning-main.embedded-mode {
  height: calc(100vh - 82px);
  padding: 0 26px 18px;
}

.warning-main.embedded-mode .warning-alert-board,
.warning-main.embedded-mode .warning-record {
  top: 0;
}

.migrateMap {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background-color: #555;
  z-index: 0;
}

.data-box {
  background-color: rgba(3, 10, 69, 0.92);
  box-shadow: -1px -1px 10px 2px rgba(78, 240, 228, 0.1);
  background-image: url(../../static/img/border-top.png), url(../../static/img/border-bottom.png);
  background-repeat: no-repeat, no-repeat;
  background-position: -0.3% -0.3%, 100.3% 100.3%;
  border: 1px solid rgba(80, 220, 255, 0.28);
}

.warning-left,
.warning-right {
  position: relative;
  z-index: 2;
  width: 456px;
  height: 100%;
  margin-top: 20px;
}

.warning-left {
  float: left;
}

.warning-right {
  float: right;
}

.warning-panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 20px 18px 16px;
  box-sizing: border-box;
  overflow: hidden;
}

.warning-panel-large {
  height: calc(100% - 250px);
  min-height: 640px;
}

.warning-panel-small {
  margin-top: 14px;
  height: 236px;
}

.parking-panel {
  height: calc(50% - 8px);
}

.parking-panel + .parking-panel {
  margin-top: 16px;
}

.warning-panel-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 18px;
}

.traffic-gateway-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.traffic-gateway-subtitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  color: #8cefff;
  font-size: 12px;
  font-weight: 600;
}

.traffic-gateway-block {
  min-width: 0;
}

.traffic-gateway-subtitle span {
  color: rgba(255, 255, 255, 0.65);
  font-size: 11px;
}

.traffic-bar-row {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr) 36px;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  color: #fff;
  font-size: 12px;
}

.traffic-bar-label {
  color: rgba(255, 255, 255, 0.86);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.traffic-bar-track {
  position: relative;
  min-width: 0;
  height: 8px;
  background: rgba(45, 72, 180, 0.45);
  border: 1px solid rgba(132, 159, 255, 0.16);
}

.traffic-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #6fb8ff 0%, #ff5a8f 100%);
}

.traffic-bar-value {
  color: rgba(255, 255, 255, 0.8);
  text-align: right;
  white-space: nowrap;
}

.warning-section-title {
  display: flex;
  align-items: center;
  margin-top: 18px;
  margin-bottom: 10px;
  color: #d7f7ff;
  font-size: 13px;
  font-weight: 600;
}

.warning-section-title span {
  margin-left: 8px;
  color: rgba(255, 255, 255, 0.58);
  font-size: 10px;
  font-weight: 400;
}

.warning-section-title-small {
  margin-top: 16px;
}

.road-tabs {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}

.road-tab {
  width: 72px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  color: rgba(255, 255, 255, 0.65);
  font-size: 11px;
  border: 1px solid rgba(98, 161, 255, 0.25);
}

.road-tab-active {
  background: rgba(112, 203, 255, 0.28);
  color: #d9ffff;
}

.table-box {
  display: flex;
  flex-direction: column;
  min-height: 0;
  border: 1px solid rgba(89, 197, 255, 0.18);
  overflow: hidden;
}

.table-box-compact {
  max-height: 184px;
}

.table-scroll-body {
  position: relative;
  overflow: hidden;
}

.road-scroll-body {
  height: 160px;
}

.rail-scroll-body {
  height: 158px;
}

.county-scroll-body {
  flex: 1;
  min-height: 0;
}

.parking-scroll-body {
  flex: 1;
  min-height: 0;
}

.table-scroll-inner {
  display: flex;
  flex-direction: column;
}

.table-scroll-inner.is-scrollable {
  animation-name: warning-table-scroll;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

.table-scroll-body:hover .table-scroll-inner.is-scrollable {
  animation-play-state: paused;
}

.table-header,
.table-row {
  display: grid;
  align-items: center;
  min-height: 32px;
  padding: 0 10px;
  box-sizing: border-box;
  color: rgba(255, 255, 255, 0.9);
}

.table-header span,
.table-row span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-header {
  background: rgba(70, 156, 219, 0.22);
  color: #8cefff;
  font-size: 11px;
  font-weight: 600;
}

.table-row {
  font-size: 12px;
  border-top: 1px solid rgba(89, 197, 255, 0.08);
}

@keyframes warning-table-scroll {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}

.table-name {
  color: rgba(255, 255, 255, 0.96);
}

.traffic-table-grid {
  grid-template-columns: minmax(0, 1.45fr) minmax(0, 0.82fr) minmax(0, 1.14fr) minmax(0, 0.82fr) minmax(0, 1.14fr);
}

.railway-table-grid {
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr);
}

.county-table-grid {
  grid-template-columns: minmax(0, 1.48fr) minmax(0, 0.82fr) minmax(0, 1.2fr);
}

.parking-table-grid {
  grid-template-columns: minmax(0, 1.95fr) minmax(0, 0.68fr) minmax(0, 0.68fr) minmax(0, 0.62fr) minmax(0, 0.62fr) minmax(0, 1.12fr);
}

.table-progress-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.table-progress-track {
  display: block;
  flex: 0 0 48px;
  width: 48px;
}

.table-progress-fill-high {
  background: linear-gradient(90deg, #34d399 0%, #7ef7bf 100%);
}

.table-progress-fill-medium {
  background: linear-gradient(90deg, #3f66ff 0%, #00d8ff 100%);
}

.table-progress-fill-low {
  background: linear-gradient(90deg, #ff9c3b 0%, #ffd53a 100%);
}

.load-high {
  color: #56f2a0;
}

.load-medium {
  color: #4da8ff;
}

.load-low {
  color: #ff9f43;
}

.warning-right .warning-panel-title {
  margin-bottom: 12px;
  flex-shrink: 0;
}

.parking-top-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  flex-shrink: 0;
}

.parking-top-list {
  min-width: 0;
}

.parking-top-title {
  margin-bottom: 8px;
  color: #8cefff;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.parking-rank-row {
  display: grid;
  grid-template-columns: 18px minmax(0, 1.6fr) minmax(0, 0.9fr) 42px;
  align-items: center;
  gap: 6px;
  margin-bottom: 7px;
  font-size: 11px;
  color: #fff;
}

.parking-rank-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: linear-gradient(180deg, #ff7f7f 0%, #5575ff 100%);
  font-size: 10px;
}

.parking-rank-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.parking-rank-track {
  display: block;
  min-width: 0;
  height: 6px;
  background: rgba(44, 63, 150, 0.5);
  overflow: hidden;
}

.parking-rank-fill {
  display: block;
  height: 100%;
  border-radius: 4px;
}

.parking-rank-fill-cyan {
  background: linear-gradient(90deg, #3f66ff 0%, #00d8ff 100%);
}

.parking-rank-fill-gold {
  background: linear-gradient(90deg, #ff9c3b 0%, #ffd53a 100%);
}

.parking-rank-value {
  text-align: right;
  font-weight: 600;
}

.parking-rank-value-green {
  color: #70ff9f;
}

.parking-rank-value-gold {
  color: #ffd65f;
}

.parking-table-title {
  margin-top: 12px;
  flex-shrink: 0;
}

.parking-table-box {
  flex: 1;
  min-height: 0;
  height: auto;
}

.warning-record {
  position: absolute;
  top: 20px !important;
  left: 486px;
  z-index: 3;
  width: 236px;
  padding: 12px 16px;
  box-sizing: border-box;
  background: rgba(11, 24, 112, 0.88);
  border: 1px solid rgba(82, 150, 255, 0.3);
}

.warning-record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.warning-record-close {
  font-size: 26px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.45);
  cursor: pointer;
}

.warning-record-summary {
  margin-top: 18px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 12px;
}

.warning-record-count {
  color: #ff4970;
  font-weight: 700;
}

.warning-alert-board {
  position: absolute;
  top: 28px;
  left: 50%;
  transform: translateX(-2%);
  z-index: 3;
  display: flex;
  align-items: center;
  min-width: 368px;
  max-width: 520px;
  height: 40px;
  padding: 0 16px;
  box-sizing: border-box;
  background: linear-gradient(90deg, rgba(8, 34, 70, 0.92) 0%, rgba(9, 46, 78, 0.72) 100%);
  border: 1px solid rgba(1, 241, 227, 0.28);
  box-shadow: 0 0 12px rgba(1, 241, 227, 0.12);
}

.warning-alert-icon {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  margin-right: 10px;
  border-radius: 4px;
  background: rgba(255, 74, 74, 0.18);
  color: #ff4a4a;
  font-size: 15px;
  font-weight: 700;
}

.warning-alert-text {
  color: rgba(255, 255, 255, 0.95);
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.warning-map-actions {
  position: absolute;
  left: 50%;
  bottom: 22px;
  transform: translateX(-50%);
  z-index: 3;
}

.warning-map-button {
  min-width: 212px;
  height: 38px;
  line-height: 38px;
  padding: 0 18px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  border-radius: 3px;
  background: linear-gradient(90deg, #3d90d8 0%, #5eb5f4 100%);
  box-shadow: 0 8px 20px rgba(54, 137, 213, 0.25);
  cursor: pointer;
}

.bus-route-modal {
  position: fixed;
  inset: 0;
  z-index: 30;
}

.bus-route-mask {
  position: absolute;
  inset: 0;
  background: rgba(2, 8, 30, 0.72);
  backdrop-filter: blur(4px);
}

.bus-route-dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 86vw;
  height: 82vh;
  transform: translate(-50%, -50%);
  padding: 18px 18px 16px;
  box-sizing: border-box;
  z-index: 31;
}

.bus-route-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.bus-route-title {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
}

.bus-route-close {
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  color: rgba(255, 255, 255, 0.72);
  font-size: 28px;
  cursor: pointer;
}

.bus-route-body {
  display: flex;
  gap: 16px;
  height: calc(100% - 46px);
}

.bus-route-sidebar {
  width: 360px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bus-route-card {
  padding: 14px 16px;
  background: rgba(11, 27, 88, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.18);
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.bus-route-card-active {
  background: rgba(17, 45, 132, 0.82);
  border-color: rgba(255, 215, 106, 0.72);
  box-shadow: 0 0 16px rgba(255, 215, 106, 0.12);
}

.bus-route-card-disabled {
  opacity: 0.65;
}

.bus-route-card-title {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bus-route-card-subtitle {
  margin-top: 6px;
  color: #8cefff;
  font-size: 12px;
}

.bus-route-card-status {
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 12px;
}

.bus-route-card-realtime {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.88);
  font-size: 12px;
  line-height: 1.5;
}

.bus-route-card-realtime span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bus-route-card-realtime-sub {
  display: block;
  color: rgba(140, 239, 255, 0.92);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bus-route-card-ok {
  color: #70ff9f;
}

.bus-route-card-error {
  color: #ff8a8a;
}

.bus-route-live-panel {
  margin-top: 14px;
  padding: 14px 14px 12px;
  background: rgba(9, 30, 88, 0.82);
  border: 1px solid rgba(112, 203, 255, 0.18);
}

.bus-route-live-title {
  color: #ffd76a;
  font-size: 13px;
  font-weight: 700;
}

.bus-route-live-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 14px;
  margin-top: 12px;
}

.bus-route-live-item {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
  color: rgba(255, 255, 255, 0.84);
  font-size: 12px;
}

.bus-route-live-item-wide {
  grid-column: 1 / -1;
}

.bus-route-live-label {
  color: #8cefff;
  flex-shrink: 0;
}

.bus-route-live-value {
  min-width: 0;
  text-align: right;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bus-route-detail {
  flex: 1;
  min-height: 0;
  padding: 16px;
  background: rgba(5, 16, 61, 0.86);
  border: 1px solid rgba(76, 165, 255, 0.16);
  overflow: auto;
}

.bus-route-detail-title {
  color: #fff;
  font-size: 18px;
  font-weight: 700;
}

.bus-route-detail-desc {
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 13px;
  line-height: 1.6;
}

.bus-route-detail-table {
  margin-top: 14px;
}

.bus-route-detail-row {
  display: flex;
  gap: 12px;
  padding: 10px 0;
  border-top: 1px solid rgba(95, 179, 255, 0.1);
  font-size: 13px;
  line-height: 1.6;
}

.bus-route-detail-row:first-child {
  border-top: 0;
}

.bus-route-detail-label {
  width: 88px;
  flex-shrink: 0;
  color: #8cefff;
  font-weight: 600;
}

.bus-route-detail-value {
  min-width: 0;
  color: rgba(255, 255, 255, 0.92);
  word-break: break-all;
}

.bus-route-detail-tip {
  margin-top: 14px;
  color: rgba(255, 214, 106, 0.88);
  font-size: 12px;
  line-height: 1.7;
}

.bus-route-map-wrapper {
  position: relative;
  flex: 1;
  min-width: 0;
  background: rgba(6, 17, 54, 0.72);
  border: 1px solid rgba(76, 165, 255, 0.16);
  overflow: hidden;
}

.bus-route-map {
  width: 100%;
  height: 100%;
}

.bus-route-simulation-badge {
  position: absolute;
  top: 18px;
  right: 18px;
  z-index: 3;
  padding: 8px 12px;
  background: rgba(255, 215, 106, 0.14);
  border: 1px solid rgba(255, 215, 106, 0.32);
  color: #ffd76a;
  font-size: 12px;
}

.bus-route-loading,
.bus-route-error {
  position: absolute;
  top: 18px;
  left: 18px;
  z-index: 3;
  padding: 8px 12px;
  background: rgba(8, 26, 82, 0.82);
  color: #fff;
  font-size: 12px;
}

.bus-route-error {
  color: #ff9b9b;
}

/deep/ .bus-endpoint-marker {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  text-align: center;
  line-height: 28px;
  color: #08183b;
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0 0 12px rgba(255, 215, 106, 0.35);
}

/deep/ .bus-endpoint-marker-起 {
  background: #70ff9f;
}

/deep/ .bus-endpoint-marker-终 {
  background: #ffd76a;
}

/deep/ .bus-stop-window {
  padding: 4px 8px;
  color: #1b1b1b;
  font-size: 12px;
}

/deep/ .bus-vehicle-marker {
  position: relative;
  width: 36px;
  height: 36px;
}

/deep/ .bus-vehicle-pulse {
  position: absolute;
  inset: 6px;
  border-radius: 50%;
  opacity: 0.22;
  animation: bus-vehicle-pulse 1.8s ease-out infinite;
}

/deep/ .bus-vehicle-body {
  position: relative;
  z-index: 1;
  width: 36px;
  height: 36px;
  line-height: 32px;
  text-align: center;
  border-radius: 50%;
  border: 2px solid #4aa7ff;
  background: rgba(7, 20, 58, 0.94);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  box-sizing: border-box;
}

/deep/ .bus-realtime-window {
  min-width: 190px;
  padding: 2px 0;
  color: #1b1b1b;
  font-size: 12px;
  line-height: 1.7;
}

/deep/ .bus-realtime-window-title {
  margin-bottom: 4px;
  font-size: 13px;
  font-weight: 700;
}

/deep/ .bus-realtime-window-line {
  white-space: nowrap;
}

/deep/ .bus-realtime-window-tip {
  margin-top: 4px;
  color: #ff9f43;
}

@keyframes bus-vehicle-pulse {
  0% {
    transform: scale(0.72);
    opacity: 0.32;
  }
  100% {
    transform: scale(1.3);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ScenicWarning.vue